import React from "react";
import Button from "../components/Button";

import ShowInfo from "../components/ShowInfo";
import styles from "./Prepare.module.css";

function Prepare(props) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.body}>
        <ShowInfo />
        <Button onClick={() => props.navigateNextPage()}>
          เริ่มต้นการทดสอบ
        </Button>
      </div>
    </div>
  );
}

export default Prepare;


